export var QUICKLINKS_MENU='quicklinks';export var LEGAL_MENU='legal';